<template>
  <div class="gmf-context">
    <div class="gmf-text-small">{{ commentCount }} {{t('social_feed.x_comments')}}</div>
  </div>
</template>

<script>
/* @TODO fel fras här... använd rätt fras */

import callApi from '@/utils/callApi';
import state from '@/state';
const t = state.t;

export default {
  props: ['productId'],
  data () {
    return {
      commentCount: 0,
    };
  },
  methods: {
    t,
  },
  async mounted () {
    const res = await callApi('GET', '/v3/comments/search?take=0&product_id:group=' + this.productId);
    const { totalCount } = await res.json();
    this.commentCount = totalCount;
  },
};
</script>
